/* BLACK FRIDAY campaign runtime: countdowns, product-page deal card, sticky bar, badges, A/B tag */
(function () {
  var C = window.BF || {}, html = document.documentElement;
  if (!html.classList.contains('bf-on')) return;

  var end = Date.parse(C.end);
  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function tick() {
    if (isNaN(end)) return;
    var ms = end - Date.now();
    if (ms <= 0) {
      if (C.autohide) { html.classList.remove('bf-on'); return; }
      ms = 0;
    }
    html.classList.toggle('bf-final', C.cdHours > 0 && ms < C.cdHours * 3600000);
    var s = Math.floor(ms / 1000),
      d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600),
      m = Math.floor((s % 3600) / 60), x = s % 60,
      txt = (d > 0 ? d + (C.dayUnit || 'd') + ' ' : '') + pad(h) + ':' + pad(m) + ':' + pad(x);
    document.querySelectorAll('[data-bf-cd]').forEach(function (el) { el.textContent = txt; });
    document.querySelectorAll('[data-bf-cdbox]').forEach(function (box) {
      var u = { d: pad(d), h: pad(h), m: pad(m), s: pad(x) };
      box.querySelectorAll('[data-u]').forEach(function (b) { b.textContent = u[b.getAttribute('data-u')]; });
    });
  }

  function badge(container, cls) {
    if (!container || container.querySelector('.bf-imgbadge')) return;
    var b = document.createElement('span');
    b.className = 'bf-imgbadge bf-x' + (cls ? ' ' + cls : '');
    b.textContent = C.badgeText || 'BLACK FRIDAY';
    container.classList.add('bf-imgwrap');
    container.appendChild(b);
  }

  function productPage() {
    var info = document.querySelector('.product__info-container');
    var card = null, tpl = document.getElementById('bf-deal-tpl');

    if (C.pdpCard && tpl) {
      card = tpl.content.firstElementChild.cloneNode(true);
      var anchor = null;
      if (info) {
        var buy = info.querySelector('kaching-bundle, kaching-bundles-block, product-form, form[action*="/cart/add"]');
        if (buy) {
          anchor = buy;
          while (anchor.parentElement && anchor.parentElement !== info) anchor = anchor.parentElement;
          if (anchor.parentElement !== info) anchor = null;
        }
      }
      if (anchor) info.insertBefore(card, anchor);
      else if (info) {
        var price = info.querySelector(':scope > [id^="price-"]');
        info.insertBefore(card, price ? price.nextSibling : info.firstChild);
      }
      else { var main = document.getElementById('MainContent'); if (main) main.insertBefore(card, main.firstChild); }
    }

    if (C.imgBadge) badge(document.querySelector('.product__media-wrapper'));

    var bar = document.querySelector('[data-bf-sticky]');
    if (bar && C.sticky) {
      document.body.appendChild(bar);
      var target = card || (info && info.querySelector('kaching-bundle, product-form')) || info;
      var inView = true;
      function update() {
        var past = target ? target.getBoundingClientRect().bottom < 0 : window.scrollY > 600;
        bar.classList.toggle('is-shown', !inView && past);
      }
      if (target && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (e) { inView = e[0].isIntersecting; update(); }).observe(target);
      } else { inView = false; }
      window.addEventListener('scroll', update, { passive: true });
      bar.querySelector('[data-bf-sticky-btn]').addEventListener('click', function () {
        var t = (info && info.querySelector('kaching-bundle, product-form')) || card || info;
        if (t) t.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
      update();
    }
  }

  function cardBadges() {
    if (!C.cardBadge) return;
    document.querySelectorAll('.card-wrapper .card__inner .card__media').forEach(function (m) { badge(m.parentElement, 'bf-cardbadge'); });
  }

  // Record which message a visitor saw on the cart, so orders show the A/B arm (Additional details → _bf_msg)
  function tagCart() {
    if (C.mode !== 'split' || !C.variant) return;
    try { if (sessionStorage.getItem('bfMsgTagged') === C.variant) return; } catch (e) {}
    fetch('/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { _bf_msg: C.variant } })
    }).then(function (r) { if (r.ok) try { sessionStorage.setItem('bfMsgTagged', C.variant); } catch (e) {} }).catch(function () {});
  }
  // Black Friday: the gift row is added to every bundle bar here, so live themes and the shared bundle config stay as they are
  function giftRows() {
    var tpl = document.getElementById('bf-gift-row-tpl');
    if (!tpl) return;
    function apply() {
      document.querySelectorAll('.sfkb__bar, .sfb__bar').forEach(function (bar) {
        if (bar.querySelector('.bf-gifts')) return;
        (bar.querySelector('label') || bar).appendChild(tpl.content.firstElementChild.cloneNode(true));
      });
    }
    apply();
    new MutationObserver(apply).observe(document.body, { childList: true, subtree: true });
  }

  tick();
  setInterval(tick, 1000);
  if (C.isProduct) { productPage(); giftRows(); }
  cardBadges();
  tagCart();
})();
